/*
 * Aura Golf - Mobile docked add-to-cart bar.
 * Reveals a slim bottom bar once the real add-to-cart button leaves the
 * viewport, and proxies its click to the real submit button so Dawn's
 * product-form.js performs the add. Pure progressive enhancement: if anything
 * is missing the bar simply never appears.
 */
(function () {
  function init(bar) {
    if (bar._stickyInit) return;
    var realBtn = document.getElementById(bar.getAttribute('data-target'));
    var proxy = bar.querySelector('[data-sticky-add]');
    var label = bar.querySelector('[data-sticky-label]');
    if (!realBtn || !proxy) return;
    bar._stickyInit = true;
    bar._stickyObservers = [];

    // Dawn disables the button two ways: the `disabled` attribute (sold out /
    // unavailable variant) and `aria-disabled="true"` (in-flight submit, or a
    // sold-out AJAX response). Treat either as "do not proxy".
    function isDisabled() {
      return (
        realBtn.hasAttribute('disabled') ||
        realBtn.getAttribute('aria-disabled') === 'true'
      );
    }

    // Proxy the click to the real submit button (respects disabled state).
    proxy.addEventListener('click', function () {
      if (isDisabled()) return;
      realBtn.click();
    });

    // Mirror the real button's disabled state + label (sold out, unavailable).
    function sync() {
      var disabled = isDisabled();
      if (disabled) {
        proxy.setAttribute('disabled', '');
      } else {
        proxy.removeAttribute('disabled');
      }
      var realLabel = realBtn.querySelector('span');
      if (realLabel && label) label.textContent = realLabel.textContent.trim();
    }
    sync();

    if (window.MutationObserver) {
      var mo = new MutationObserver(sync);
      mo.observe(realBtn, { attributes: true, childList: true, subtree: true });
      bar._stickyObservers.push(mo);
    }

    // Reveal the bar only while the real button is out of view.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var show = !entry.isIntersecting;
            bar.classList.toggle('is-visible', show);
            bar.setAttribute('aria-hidden', show ? 'false' : 'true');
          });
        },
        { rootMargin: '0px 0px -15% 0px' }
      );
      io.observe(realBtn);
      bar._stickyObservers.push(io);
    }
  }

  function boot(root) {
    (root || document).querySelectorAll('[data-sticky-atc]').forEach(init);
  }

  // Theme editor re-renders sections; disconnect observers so they don't leak.
  function teardown(root) {
    (root || document).querySelectorAll('[data-sticky-atc]').forEach(function (bar) {
      if (bar._stickyObservers) {
        bar._stickyObservers.forEach(function (o) { o.disconnect(); });
        bar._stickyObservers = [];
      }
      bar._stickyInit = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { teardown(e.target); });
})();
